/*
* Project: LegalPlace assistant
* File: src/middlewares/logging.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

function initializeLogger() {
  window.lpFlat_loops = 0;
  window.lpOption_loop = 0;
  window.lpVariable_loop = 0;
}

function firedFlat() {
  window.lpFlat_loops += 1;
}
function firedOption() {
  window.lpOption_loop += 1;
}
function firedVariable() {
  window.lpVariable_loop += 1;
}

export {
  initializeLogger,
  firedFlat,
  firedOption,
  firedVariable,
};



// WEBPACK FOOTER //
// ./src/middlewares/logging.js